import React from 'react';
import { Button, RichTextViewer, /* Accordion */ } from '@prosolve/common-components-ui'
import { FaFileAlt, FaFilePdf } from 'react-icons/fa';

export default ({
  eventData = {},
  isStarSubdomain
}) => {

  const {
    eventBlueprintDocument: eventBlueprintDocumentRaw = '',
    slideDeckLink: slideDeckLinkRaw = '',
    eventTemplateBlueprintDocument = '',
    eventTemplateSlideDeckLink = '',
    internalPlanningGuideLink = '',
    projectIdNumber = '',
    customerSuccessNotes = '',
    handoutsProvided = false
  } = eventData;

  const eventBlueprintDocument = isStarSubdomain ? 
    ( 
      eventBlueprintDocumentRaw ? (eventBlueprintDocumentRaw === '-' ? '' : eventBlueprintDocumentRaw)
      : eventTemplateBlueprintDocument
    )
    : eventBlueprintDocumentRaw;
  
  const slideDeckLink = isStarSubdomain ? 
    ( 
      slideDeckLinkRaw ? (slideDeckLinkRaw === '-' ? '' : slideDeckLinkRaw)
      : eventTemplateSlideDeckLink
    )
    : slideDeckLinkRaw;

  // TODO: Currently provided blueprint is not embedded version, so it would need to be in a new created SF field (and managed)

  // const blueprintUrl = "https://docs.google.com/document/d/e/2PACX-1vSbq1uny-7iGkE8DfDtjU6yr6ArDAh1cOQ5h4tUF48b50IrUikcnyhnY0vvQMmXbg/pub?embedded=true";

  const openBlueprintInNewTab = () => {
    window.open(eventBlueprintDocument, "Event Blueprint")
  }

  const openInternalPlanningGuideInNewTab = () => {
    window.open(internalPlanningGuideLink, "Internal Planning Guide")
  }

  const openSlideDeckInNewTab = () => {
    window.open(slideDeckLink, "Slide Deck")
  }

  return (
    <div>
      <div style={{ padding: '20px' }}>
        <Button
          $disabled={!Boolean(eventBlueprintDocument)}
          style={{
            display: 'inline-flex',
            border: 'none',
            position: 'relative',
            background: '#ffffff'
          }}
          onClick={Boolean(eventBlueprintDocument) ? openBlueprintInNewTab : undefined}
        >
          {Boolean(eventBlueprintDocument)
            ?
            <>
              <span style={{ fontWeight: 'bold', color: '#565656', fontSize: '20px' }}>{isStarSubdomain ? 'Open Blueprint in New Tab' : 'Open Document in New Tab'}</span>
              <FaFilePdf style={{ marginLeft: '10px', color: '#0280c6', fontSize: '18px' }} />
            </>
            :
            <span style={{ fontWeight: 'bold', color: '#565656', fontSize: '20px' }}>{'No Facilitation Guide Document is available'}</span>
          }
        </Button>
      </div>
      {
        !isStarSubdomain &&
        <div style={{ padding: '20px' }}>
          <Button
            $disabled={!Boolean(internalPlanningGuideLink)}
            style={{
              display: 'inline-flex',
              border: 'none',
              position: 'relative',
              background: '#ffffff'
            }}
            onClick={Boolean(internalPlanningGuideLink) ? openInternalPlanningGuideInNewTab : undefined}
          >
            {Boolean(internalPlanningGuideLink) 
              ? 
              <>
                <span style={{ fontWeight: 'bold', color: '#565656', fontSize: '20px' }}>{'Open Internal Planning Guide in New Tab'}</span>
                <FaFilePdf style={{ marginLeft: '10px', color: '#0280c6', fontSize: '18px' }} />
              </>
              : 
              <span style={{ fontWeight: 'bold', color: '#565656', fontSize: '20px' }}>{'No Internal Planning Guide is available'}</span>
            }
          </Button>
        </div>
      }
      <div style={{ padding: '20px' }}>
        <Button
          $disabled={!Boolean(slideDeckLink)}
          style={{
            display: 'inline-flex',
            border: 'none',
            position: 'relative',
            background: '#ffffff'
          }}
          onClick={Boolean(slideDeckLink) ? openSlideDeckInNewTab : undefined}
        >
          {Boolean(slideDeckLink) 
            ? 
            <>
              <span style={{ fontWeight: 'bold', color: '#565656', fontSize: '20px' }}>{'Open Slide Deck in New Tab'}</span>
              <FaFilePdf style={{ marginLeft: '10px', color: '#0280c6', fontSize: '18px' }} />
            </>
            : 
            <span style={{ fontWeight: 'bold', color: '#565656', fontSize: '20px' }}>{'No Slide Deck is available'}</span>
          }
        </Button>
      </div>
      {
        !isStarSubdomain &&
        <div style={{ padding: '20px 30px', fontWeight: 'bold', color: '#565656', fontSize: '20px' }}>
           {Boolean(projectIdNumber) ? `Survey Code: ${projectIdNumber}` : 'No Survey Code is available'}
        </div>
      }
      <div>
        <div style={{
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: '#565656',
          border: '1px solid #dedede',
          borderRadius: '5px',
          background: '#fdfdfd',
          padding: '20px',
          margin: '10px 20px'
        }}>
          {handoutsProvided 
            ? 
            <>
              <FaFileAlt style={{ marginBottom: '2px', color: '#0280c6', fontSize: '24px' }} />
              <span style={{ fontWeight: 'bold', paddingLeft: '10px' }}>{'Handouts Have Been Provided'}</span>
            </>
            : 
            <span style={{ fontWeight: 'bold' }}>{'No Handouts Have Been Provided'}</span>
          }
        </div>
      </div>
      {
        isStarSubdomain &&
        <div>
          <div style={{
            display: 'inline-flex',
            flexDirection: 'column',
            color: '#565656',
            border: '1px solid #dedede',
            borderRadius: '5px',
            background: '#fdfdfd',
            padding: '20px',
            margin: '20px'
          }}>
            <div style={{ fontWeight: 'bold' }}>{'Trainer Prep: Event Context'}</div>
            {Boolean(customerSuccessNotes) 
              ?
              <RichTextViewer style={{ marginTop: '10px' }} value={customerSuccessNotes} />
              :
              <div style={{ marginTop: '10px' }}>No Trainer Prep: Event Context is available</div>
            }
          </div>
        </div>
      }
      {/* <Accordion
        title={<div style={{ padding: '0px 25px', color: '#565656', fontSize: '20px', fontWeight: 'bold' }}>{'Embedded Blueprint'}</div>}
        defaultOpen={true}
        headerExpands={true}
        style={{ padding: '20px 5px 20px 5px' }}
        expandedStyle={{ padding: '0px 0px 10px 0px' }}
      >
        <div>
          <iframe
            style={{
              width: '100%',
              height: '30000px',
              border: 'none'
            }}
            title='eventBluePrintIframe'
            src={eventBlueprintDocument}
          >
          </iframe>
        </div>
      </Accordion> */}
    </div>
  )
}